import update from 'immutability-helper';

export const initialState = {
  byId: {},
  otp: null,
  userId: null
};

export function user(state = initialState, action) {
  switch (action.type) {
  case 'FOLDER_PERMISSIONS_RECEIVE':
    return update(state, {
      byId: {
        [action.payload.user_id]: {
          $apply: user => {
            return Object.assign({}, user, {
              permissions: update(user && user.permissions || {}, {
                [action.payload.folder_id]: {
                  $set: action.payload.permissions
                }
              })
            });
          }
        }
      }
    });
  case 'USER_RECEIVE':
    return update(state, {
      userId: {$set: action.payload.id},
      byId: {
        [action.payload.id]: {
          $apply: user => Object.assign(user || {}, action.payload)
        }
      }
    });
  case 'SET_SEARCH_PARAMS': {
    const hasOtpProperty = Object.prototype.hasOwnProperty.call(action.payload, 'otp');

    // Requires the OTP to be explicitly set in the action's payload for it to have any
    // effect on the OTP in state. This is to ensure that the OTP isn't removed just
    // because of its absence in a particular action.
    if (!hasOtpProperty) {
      return state;
    }

    const {otp} = action.payload;

    // Once the OTP has been set it shouldn't need to change, so this is an aid to help
    // flag up any unexpected behaviour.
    if (state.otp && otp !== state.otp) {
      // eslint-disable-next-line no-console
      console.warn(`Changing OTP from "${state.otp}" to "${otp}".`);
    }

    return update(state, {
      otp: {$set: otp}
    });
  }
  default:
    return state;
  }
}
